@if (isMenu) {
  @if (showButton) {
    <button
      mat-menu-item
      [attr.aria-label]="'validate' | translate"
      [disabled]="disabled">
      <mat-icon>check_circle_outline</mat-icon>
      {{ 'validate' | translate }}
    </button>
  }
} @else {
  <app-loading-icon-button
    label="validate"
    icon="check_circle_outline"
    [showButton]="showButton"
    [disabled]="disabled"
    [showLoading]="showLoading">
  </app-loading-icon-button>
}
